var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoFilled = function SvgInfoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm1.162-11.765-1.25 5.881c-.087.425.037.666.38.666.243 0 .61-.087.858-.307l-.11.52c-.359.432-1.15.747-1.831.747-.879 0-1.253-.527-1.01-1.648l.922-4.335c.08-.367.008-.499-.359-.588l-.563-.101.102-.476 2.861-.359ZM12 8.875a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z"
  })));
};
export default SvgInfoFilled;